import React from 'react';
import { motion } from 'framer-motion';
import { FaHome, FaWater, FaUsers, FaHandHoldingHeart, FaBuilding, FaExternalLinkAlt } from 'react-icons/fa';
import { translations } from '../i18n';
function Schemes({ language }) {
  const t = translations[language];

  const schemes = [
    {
      title: 'जल जीवन मिशन',
      description: 'ग्रामीण भागातील प्रत्येक घरात स्वच्छ पिण्याचे पाणी पुरवठा करण्याचे उद्दिष्ट',
      icon: <FaWater />,
      color: '#3498db',
      link: 'https://water.maharashtra.gov.in/jal-jeevan-mission/',
      details: [
        'प्रत्येक ग्रामीण घरात नळ कनेक्शन',
        'पाण्याची गुणवत्ता सुनिश्चित करणे',
        'पाणी पुरवठा व्यवस्थापन'
      ]
    },
    {
      title: 'प्रधान मंत्री आवास योजना – ग्रामीण',
      description: 'ग्रामीण भागातील दारिद्रय रेषेखालील बेघर/कच्चेघर असलेल्या कुटुंबांना घरकुल बांधकामासाठी अर्थसहाय्य',
      icon: <FaHome />,
      color: '#e74c3c',
      details: [
        'साधारण क्षेत्रासाठी: रु. 1.20 लाख प्रति लाभार्थी',
        'नक्षलग्रस्त भागासाठी: रु. 1.30 लाख प्रति लाभार्थी',
        'PFMS प्रणालीद्वारे थेट बँक खात्यात अनुदान',
        'MGNREGA अंतर्गत ९०/९५ दिवसांची अतिरिक्त मजुरी'
      ],
      eligibility: [
        'लाभार्थी दारिद्रय रेषेखालील असावा',
        'कायम प्रतिक्षा यादीत नाव असणे आवश्यक',
        'घरकुल बांधकामासाठी स्वतःची जागा असावी'
      ]
    },
    {
      title: 'महात्मा गांधी राष्ट्रीय ग्रामीण रोजगार हमी योजना (MGNREGA)',
      description: 'ग्रामीण भागातील कुटुंबाला १०० दिवसांचा रोजगार उपलब्ध करून देण्याची हमी',
      icon: <FaUsers />,
      color: '#2ecc71',
      details: [
        'प्रति कुटुंब १०० दिवसांचा रोजगार हमी',
        'किमान मजुरीची हमी',
        'अर्ज केल्यापासून १५ दिवसांत रोजगार',
        'कुटुंबातील सर्व प्रौढ व्यक्ती नोंदणी करू शकतात',
        'नोंदणीचा कालावधी ५ वर्षे'
      ],
      responsibilities: [
        'ग्रामपंचायत: नोंदणी, कामाची मागणी, मजुरी वाटप',
        'तालुका: नियोजन मार्गदर्शन, निधी व्यवस्थापन',
        'जिल्हा: एकूण नियोजन, निधी हिशोब, नियंत्रण'
      ]
    },
    {
      title: 'तांडा / वस्ती योजना',
      description: 'अनुसूचित जाती व नवबौद्ध घटकांच्या मुलभूत गरजा भागविण्यासाठी',
      icon: <FaBuilding />,
      color: '#9b59b6',
      link: 'https://obcbahujankalyan.maharashtra.gov.in',
      details: [
        'स्वच्छता विषयक सोयी',
        'समाजमंदीर बांधकाम',
        'अंतर्गत रस्ते',
        'नळपाणी पुरवठा',
        'लोकसंख्येच्या प्रमाणात अनुदान'
      ]
    },
    {
      title: 'रमाई आवास योजना',
      description: 'अनुसूचित जाती व नवबौद्ध घटकांसाठी घरकुल योजना',
      icon: <FaHome />,
      color: '#f39c12',
      details: [
        'स्वतःच्या जागेवर पक्के घर बांधकाम',
        'ग्रामीण क्षेत्रासाठी वार्षिक उत्पन्न मर्यादा: रु. 1 लाख',
        'महाराष्ट्र राज्यातील किमान 15 वर्षांचे वास्तव्य आवश्यक'
      ],
      documents: [
        '७/१२ चा उतारा',
        'जातीचे प्रमाणपत्र',
        'उत्पन्नाचा दाखला',
        'बँक पासबुक',
        'आधार कार्ड, मतदार ओळखपत्र'
      ]
    },
    {
      title: 'शबरी आदिवासी घरकुल योजना',
      description: 'अनुसूचित जमातीच्या लाभार्थ्यांसाठी 269.00 चौ.फु. चटई क्षेत्र असलेले पक्के घरकुल',
      icon: <FaHome />,
      color: '#1abc9c',
      details: [
        'ग्रामीण साधारण क्षेत्र: रु. 1.32 लाख',
        'नक्षलग्रस्त व डोंगराळ क्षेत्र: रु. 1.42 लाख',
        'नगरपरिषद क्षेत्र: रु. 1.50 लाख',
        'महानगरपालिका क्षेत्र: रु. 2.00 लाख'
      ],
      eligibility: [
        'अनुसूचित जमाती संवर्गातील असावा',
        'महाराष्ट्र राज्यातील किमान 15 वर्षांचे वास्तव्य',
        'स्वतःची किंवा शासनाने दिलेली जमीन असणे आवश्यक',
        'विधवा, परित्यक्ता, निराधार लाभार्थ्यांना प्राधान्य'
      ]
    },
    {
      title: 'मोदी आवास योजना',
      description: 'आदिवासी पारधी व्यक्तींसाठी पक्की घरे बांधून देणे',
      icon: <FaHandHoldingHeart />,
      color: '#34495e',
      details: [
        'पारधी समाजातील लाभार्थ्यांसाठी विशेष योजना',
        'स्वतःची जागा अथवा कच्चे घरे असलेल्यांना लाभ',
        'विधवा, निराधार व परित्यक्त्या स्त्रियांना प्राधान्य',
        'इतर कोणत्याही योजनेतून घरकुलाचा लाभ न घेतलेल्यांना पात्रता'
      ]
    }
  ];

  return (
    <div style={{ marginTop: '80px' }}>
      {/* Hero Section */}
      <motion.section 
        className="hero" 
        style={{ height: '50vh' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="hero-content">
          <h1 className="page-hero-title">शासकीय योजना</h1>
          <p className="page-hero-sub">नागरिकांसाठी उपलब्ध सर्व शासकीय योजना</p>
        </div>
      </motion.section>

      {/* Schemes Section */}
      <section className="services-section">
        <h2 className="section-title">शासकीय योजना</h2>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          {schemes.map((scheme, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              style={{
                background: 'white',
                padding: '2.5rem',
                borderRadius: '15px',
                marginBottom: '2rem',
                boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
                border: `3px solid ${scheme.color}`,
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              {/* Background Pattern */}
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '100px',
                height: '100px',
                background: `${scheme.color}15`,
                borderRadius: '50%'
              }} />

              {/* Header */}
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                <div style={{ 
                  fontSize: '2.5rem', 
                  color: scheme.color,
                  marginRight: '1rem',
                  background: `${scheme.color}20`,
                  padding: '1rem',
                  borderRadius: '15px'
                }}>
                  {scheme.icon}
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{ color: '#2c3e50', fontSize: '1.5rem', margin: 0, marginBottom: '0.5rem' }}>
                    {scheme.title}
                  </h3>
                  <p style={{ color: '#666', margin: 0, lineHeight: '1.6' }}>
                    {scheme.description}
                  </p>
                </div>
                {scheme.link && (
                  <button
                    onClick={() => window.open(scheme.link, '_blank')}
                    style={{
                      background: scheme.color,
                      color: 'white',
                      border: 'none',
                      padding: '0.8rem',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      fontSize: '1.2rem'
                    }}
                  >
                    <FaExternalLinkAlt />
                  </button>
                )}
              </div>

              {/* Details */}
              {scheme.details && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <h4 style={{ color: scheme.color, marginBottom: '1rem' }}>योजनेचे तपशील:</h4>
                  <ul style={{ color: '#666', lineHeight: '1.8' }}>
                    {scheme.details.map((detail, idx) => (
                      <li key={idx} style={{ marginBottom: '0.5rem' }}>{detail}</li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Eligibility */}
              {scheme.eligibility && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <h4 style={{ color: scheme.color, marginBottom: '1rem' }}>पात्रता:</h4>
                  <ul style={{ color: '#666', lineHeight: '1.8' }}>
                    {scheme.eligibility.map((criteria, idx) => (
                      <li key={idx} style={{ marginBottom: '0.5rem' }}>{criteria}</li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Documents */}
              {scheme.documents && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <h4 style={{ color: scheme.color, marginBottom: '1rem' }}>आवश्यक कागदपत्रे:</h4>
                  <ul style={{ color: '#666', lineHeight: '1.8' }}>
                    {scheme.documents.map((doc, idx) => (
                      <li key={idx} style={{ marginBottom: '0.5rem' }}>{doc}</li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Responsibilities */}
              {scheme.responsibilities && (
                <div>
                  <h4 style={{ color: scheme.color, marginBottom: '1rem' }}>जबाबदाऱ्या:</h4>
                  <ul style={{ color: '#666', lineHeight: '1.8' }}>
                    {scheme.responsibilities.map((resp, idx) => (
                      <li key={idx} style={{ marginBottom: '0.5rem' }}>{resp}</li>
                    ))}
                  </ul>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </section>

      {/* Contact Section */}
      <section className="services-section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            style={{
              background: 'linear-gradient(135deg, #2c3e50, #34495e)',
              color: 'white',
              padding: '2.5rem',
              borderRadius: '15px',
              textAlign: 'center'
            }}
          >
            <h3 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>
              योजनांबाबत अधिक माहितीसाठी संपर्क करा
            </h3>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
              कोणत्याही शासकीय योजनेबाबत माहिती किंवा मदतीसाठी आपल्या स्थानिक ग्रामपंचायत कार्यालयाशी संपर्क साधा
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap' }}>
              <div>
                <strong>📧 ईमेल:</strong> gpnashera2017@gmail.com
              </div>
              <div>
                <strong>📞 फोन:</strong> +91 9623382104
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Schemes;